(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maneo-collector-studio"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('maneo-collector')) {
  customElements.define('maneo-collector', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('.mc-product-form');
      this.variantInput = this.form.querySelector('[data-canonical-variant]');
      if (!this.variantInput) {
        this.variantInput = document.createElement('input');
        this.variantInput.type = 'hidden';
        this.variantInput.name = 'id';
        this.variantInput.dataset.canonicalVariant = '';
        this.variantInput.value = this.form.querySelector('input[type="radio"]:checked')?.value || '';
        this.form.querySelectorAll('input[type="radio"][name="id"]').forEach(input => input.name = 'edition');
        this.form.prepend(this.variantInput);
      }
      this.sticky = this.querySelector('.mc-sticky');
      this.buy = this.querySelector('[data-main-buy]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"][data-available]')) this.updateVariant(event.target, true);
      }, options);
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choose]');
        if (!choice) return;
        const input = Array.from(this.querySelectorAll('input[type="radio"][data-available]')).find(input => input.value === choice.dataset.choose);
        if (!input || input.disabled) return;
        event.preventDefault();
        input.checked = true;
        this.updateVariant(input, true);
        this.form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      }, options);
      this.form.addEventListener('submit', event => {
        const selected = this.querySelector('input[type="radio"][data-available]:checked');
        if (!selected || selected.disabled || selected.dataset.available !== 'true') event.preventDefault();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.sticky.hidden = entry.isIntersecting;
      }, { threshold: 0 });
      this.observer.observe(this.buy);
      this.updateVariant(this.querySelector('input[type="radio"][data-available]:checked'), false);
    }
    updateVariant(input, updateUrl) {
      if (!input) return;
      const available = input.dataset.available === 'true';
      this.variantInput.value = input.value;
      this.variantInput.disabled = !available;
      this.querySelector('[data-express-checkout]').hidden = !available;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.querySelector('[data-current-price]').textContent = input.dataset.price;
      this.querySelector('[data-sticky-price]').textContent = input.dataset.price;
      const compare = this.querySelector('[data-current-compare]');
      compare.textContent = input.dataset.compare;
      compare.hidden = input.dataset.sale !== 'true';
      this.querySelector('[data-current-sale]').hidden = input.dataset.sale !== 'true';
      this.buy.disabled = !available;
      this.querySelector('[data-sticky-buy]').disabled = !available;
      this.querySelector('[data-button-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelector('[data-sticky-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelectorAll('[data-edition]').forEach(card => card.dataset.selected = String(card.dataset.edition === input.value));
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.ready = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maneo-everyday-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maneo-everyday')) {
  customElements.define('maneo-everyday', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('.tb-product-form');
      if (!this.form) return;
      this.variantInput = this.form.querySelector('[data-canonical-variant]');
      if (!this.variantInput) {
        this.variantInput = document.createElement('input');
        this.variantInput.type = 'hidden';
        this.variantInput.name = 'id';
        this.variantInput.dataset.canonicalVariant = '';
        this.variantInput.value = this.form.querySelector('input[type=radio]:checked')?.value || '';
        this.form.querySelectorAll('input[type=radio][name=id]').forEach(input => input.name = 'edition');
        this.form.prepend(this.variantInput);
      }
      this.sticky = this.querySelector('.tb-sticky');
      this.buy = this.querySelector('[data-main-buy]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', event => {
        if (event.target.matches('input[type=radio][data-available]')) this.updateVariant(event.target, true);
      }, options);
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choose]');
        if (!choice) return;
        const input = Array.from(this.querySelectorAll('input[type=radio][data-available]')).find(item => item.value === choice.dataset.choose);
        if (!input || input.disabled) return;
        event.preventDefault();
        input.checked = true;
        this.updateVariant(input, true);
        this.form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      }, options);
      this.form.addEventListener('submit', event => {
        const selected = this.querySelector('input[type=radio][data-available]:checked');
        if (!selected || selected.disabled || selected.dataset.available !== 'true') event.preventDefault();
      }, options);
      if (this.sticky && this.buy) {
        this.observer = new IntersectionObserver(entries => { this.sticky.hidden = entries[0].isIntersecting; }, { threshold: 0 });
        this.observer.observe(this.buy);
      }
      this.updateVariant(this.querySelector('input[type=radio][data-available]:checked'), false);
    }
    updateVariant(input, updateUrl) {
      if (!input) return;
      const available = input.dataset.available === 'true';
      const set = (selector, fn) => { const el = this.querySelector(selector); if (el) fn(el); };
      this.variantInput.value = input.value;
      this.variantInput.disabled = !available;
      set('[data-express-checkout]', el => { el.hidden = !available; });
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      set('[data-current-price]', el => { el.textContent = input.dataset.price; });
      set('[data-sticky-price]', el => { el.textContent = input.dataset.price; });
      set('[data-current-compare]', el => { el.textContent = input.dataset.compare; el.hidden = input.dataset.sale !== 'true'; });
      set('[data-current-sale]', el => { el.hidden = input.dataset.sale !== 'true'; });
      if (this.buy) this.buy.disabled = !available;
      set('[data-sticky-buy]', el => { el.disabled = !available; });
      set('[data-button-text]', el => { el.textContent = available ? this.dataset.add : this.dataset.sold; });
      set('[data-sticky-text]', el => { el.textContent = available ? this.dataset.add : this.dataset.sold; });
      this.querySelectorAll('[data-edition]').forEach(card => { card.dataset.selected = String(card.dataset.edition === input.value); });
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maneo-flamme-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maneo-flamme')) {
  customElements.define('maneo-flamme', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('.tb-product-form');
      this.variantInput = this.form.querySelector('[data-canonical-variant]');
      if (!this.variantInput) {
        this.variantInput = document.createElement('input');
        this.variantInput.type = 'hidden';
        this.variantInput.name = 'id';
        this.variantInput.dataset.canonicalVariant = '';
        this.variantInput.value = this.form.querySelector('input[type="radio"]:checked')?.value || '';
        this.form.querySelectorAll('input[type="radio"][name="id"]').forEach(input => input.name = 'edition');
        this.form.prepend(this.variantInput);
      }
      this.sticky = this.querySelector('.tb-sticky');
      this.buy = this.querySelector('[data-main-buy]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"][data-available]')) this.updateVariant(event.target, true);
      }, options);
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choose]');
        if (!choice) return;
        const input = Array.from(this.querySelectorAll('input[type="radio"][data-available]')).find(input => input.value === choice.dataset.choose);
        if (!input || input.disabled) return;
        event.preventDefault();
        input.checked = true;
        this.updateVariant(input, true);
        this.form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      }, options);
      this.form.addEventListener('submit', event => {
        const selected = this.querySelector('input[type="radio"][data-available]:checked');
        if (!selected || selected.disabled || selected.dataset.available !== 'true') event.preventDefault();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.sticky.hidden = entry.isIntersecting;
      }, { threshold: 0 });
      this.observer.observe(this.buy);
      this.updateVariant(this.querySelector('input[type="radio"][data-available]:checked'), false);
    }
    updateVariant(input, updateUrl) {
      if (!input) return;
      const available = input.dataset.available === 'true';
      this.variantInput.value = input.value;
      this.variantInput.disabled = !available;
      this.querySelector('[data-express-checkout]').hidden = !available;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.querySelector('[data-current-price]').textContent = input.dataset.price;
      this.querySelector('[data-sticky-price]').textContent = input.dataset.price;
      const compare = this.querySelector('[data-current-compare]');
      compare.textContent = input.dataset.compare;
      compare.hidden = input.dataset.sale !== 'true';
      this.querySelector('[data-current-sale]').hidden = input.dataset.sale !== 'true';
      this.buy.disabled = !available;
      this.querySelector('[data-sticky-buy]').disabled = !available;
      this.querySelector('[data-button-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelector('[data-sticky-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelectorAll('[data-edition]').forEach(card => card.dataset.selected = String(card.dataset.edition === input.value));
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maneo-halloween-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maneo-halloween')) {
  customElements.define('maneo-halloween', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('.tb-product-form');
      this.variantInput = this.form.querySelector('[data-canonical-variant]');
      if (!this.variantInput) {
        this.variantInput = document.createElement('input');
        this.variantInput.type = 'hidden';
        this.variantInput.name = 'id';
        this.variantInput.dataset.canonicalVariant = '';
        this.variantInput.value = this.form.querySelector('input[type="radio"]:checked')?.value || '';
        this.form.querySelectorAll('input[type="radio"][name="id"]').forEach(input => input.name = 'edition');
        this.form.prepend(this.variantInput);
      }
      this.sticky = this.querySelector('.tb-sticky');
      this.buy = this.querySelector('[data-main-buy]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"][data-available]')) this.updateVariant(event.target, true);
      }, options);
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choose]');
        if (!choice) return;
        const input = Array.from(this.querySelectorAll('input[type="radio"][data-available]')).find(input => input.value === choice.dataset.choose);
        if (!input || input.disabled) return;
        event.preventDefault();
        input.checked = true;
        this.updateVariant(input, true);
        this.form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      }, options);
      this.form.addEventListener('submit', event => {
        const selected = this.querySelector('input[type="radio"][data-available]:checked');
        if (!selected || selected.disabled || selected.dataset.available !== 'true') event.preventDefault();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.sticky.hidden = entry.isIntersecting;
      }, { threshold: 0 });
      this.observer.observe(this.buy);
      this.updateVariant(this.querySelector('input[type="radio"][data-available]:checked'), false);
    }
    updateVariant(input, updateUrl) {
      if (!input) return;
      const available = input.dataset.available === 'true';
      this.variantInput.value = input.value;
      this.variantInput.disabled = !available;
      this.querySelector('[data-express-checkout]').hidden = !available;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.querySelector('[data-current-price]').textContent = input.dataset.price;
      this.querySelector('[data-sticky-price]').textContent = input.dataset.price;
      const compare = this.querySelector('[data-current-compare]');
      compare.textContent = input.dataset.compare;
      compare.hidden = input.dataset.sale !== 'true';
      this.querySelector('[data-current-sale]').hidden = input.dataset.sale !== 'true';
      this.buy.disabled = !available;
      this.querySelector('[data-sticky-buy]').disabled = !available;
      this.querySelector('[data-button-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelector('[data-sticky-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelectorAll('[data-edition]').forEach(card => card.dataset.selected = String(card.dataset.edition === input.value));
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maneo-home-decks"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maneo-deck-carousel')) {
  customElements.define('maneo-deck-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = [...this.querySelectorAll('[data-deck]')];
      this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
      this.counter = this.querySelector('[data-deck-count]');
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-deck-step]');
        if (button) this.show(this.index + Number(button.dataset.deckStep));
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.target.closest('maneo-photo-carousel')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.show(index);
      }, { signal });
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => { slide.hidden = position !== this.index; });
      if (this.counter) this.counter.textContent = this.counter.dataset.pattern.replace('[current]', this.index + 1);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
if (!customElements.get('maneo-photo-carousel')) {
  customElements.define('maneo-photo-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.mh-gallery__track');
      this.frames = [...this.querySelectorAll('.mh-gallery__frame')];
      this.counter = this.querySelector('[data-photo-count]');
      this.dots = [...this.querySelectorAll('[data-photo-index]')];
      this.index = 0;
      if (!this.track || !this.frames.length) return;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-photo-index]');
        if (button) this.go(Number(button.dataset.photoIndex));
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        event.stopPropagation();
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          if (!this.track.clientWidth) return;
          this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.update();
        }, 100);
      }, { signal, passive: true });
      this.observer = new ResizeObserver(() => {
        if (this.track.clientWidth) this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
      });
      this.observer.observe(this.track);
      this.update();
    }
    go(index) {
      this.index = (index + this.frames.length) % this.frames.length;
      this.update();
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    update() {
      const start = Math.max(0, Math.min(this.index - 1, this.frames.length - this.dots.length));
      this.dots.forEach((dot, slot) => {
        const target = start + slot;
        dot.dataset.photoIndex = target;
        dot.setAttribute('aria-current', String(target === this.index));
        dot.setAttribute('aria-label', dot.dataset.label.replace('[current]', target + 1));
      });
      if (this.counter) this.counter.textContent = this.counter.dataset.pattern.replace('[current]', this.index + 1);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      clearTimeout(this.scrollTimer);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maneo-persona-studio"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('maneo-collector')) {
  customElements.define('maneo-collector', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('.mc-product-form');
      this.variantInput = this.form.querySelector('[data-canonical-variant]');
      if (!this.variantInput) {
        this.variantInput = document.createElement('input');
        this.variantInput.type = 'hidden';
        this.variantInput.name = 'id';
        this.variantInput.dataset.canonicalVariant = '';
        this.variantInput.value = this.form.querySelector('input[type="radio"]:checked')?.value || '';
        this.form.querySelectorAll('input[type="radio"][name="id"]').forEach(input => input.name = 'edition');
        this.form.prepend(this.variantInput);
      }
      this.sticky = this.querySelector('.mc-sticky');
      this.buy = this.querySelector('[data-main-buy]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"][data-available]')) this.updateVariant(event.target, true);
      }, options);
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choose]');
        if (!choice) return;
        const input = Array.from(this.querySelectorAll('input[type="radio"][data-available]')).find(input => input.value === choice.dataset.choose);
        if (!input || input.disabled) return;
        event.preventDefault();
        input.checked = true;
        this.updateVariant(input, true);
        this.form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      }, options);
      this.form.addEventListener('submit', event => {
        const selected = this.querySelector('input[type="radio"][data-available]:checked');
        if (!selected || selected.disabled || selected.dataset.available !== 'true') event.preventDefault();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.sticky.hidden = entry.isIntersecting;
      }, { threshold: 0 });
      this.observer.observe(this.buy);
      this.updateVariant(this.querySelector('input[type="radio"][data-available]:checked'), false);
    }
    updateVariant(input, updateUrl) {
      if (!input) return;
      const available = input.dataset.available === 'true';
      this.variantInput.value = input.value;
      this.variantInput.disabled = !available;
      this.querySelector('[data-express-checkout]').hidden = !available;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.querySelector('[data-current-price]').textContent = input.dataset.price;
      this.querySelector('[data-sticky-price]').textContent = input.dataset.price;
      const compare = this.querySelector('[data-current-compare]');
      compare.textContent = input.dataset.compare;
      compare.hidden = input.dataset.sale !== 'true';
      this.querySelector('[data-current-sale]').hidden = input.dataset.sale !== 'true';
      this.buy.disabled = !available;
      this.querySelector('[data-sticky-buy]').disabled = !available;
      this.querySelector('[data-button-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelector('[data-sticky-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelectorAll('[data-edition]').forEach(card => card.dataset.selected = String(card.dataset.edition === input.value));
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.ready = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maneo-related"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('maneo-related'))customElements.define('maneo-related',class extends HTMLElement{connectedCallback(){if(this.ready||this.dataset.automatic!=='true')return;this.ready=true;this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.observer.disconnect();this.load();}},{rootMargin:'400px'});this.observer.observe(this);}disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();}async load(){this.controller=new AbortController();try{const response=await fetch(this.dataset.url,{signal:this.controller.signal});if(!response.ok)return;const doc=new DOMParser().parseFromString(await response.text(),'text/html');const results=doc.querySelector('maneo-related [data-results]');if(results?.querySelector('.ms-card')&&this.isConnected)this.querySelector('[data-results]').replaceChildren(...results.childNodes);}catch(error){if(error.name!=='AbortError')this.dataset.fallback='true';}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maneo-seraphim-studio"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('maneo-collector')) {
  customElements.define('maneo-collector', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('.mc-product-form');
      this.variantInput = this.form.querySelector('[data-canonical-variant]');
      if (!this.variantInput) {
        this.variantInput = document.createElement('input');
        this.variantInput.type = 'hidden';
        this.variantInput.name = 'id';
        this.variantInput.dataset.canonicalVariant = '';
        this.variantInput.value = this.form.querySelector('input[type="radio"]:checked')?.value || '';
        this.form.querySelectorAll('input[type="radio"][name="id"]').forEach(input => input.name = 'edition');
        this.form.prepend(this.variantInput);
      }
      this.sticky = this.querySelector('.mc-sticky');
      this.buy = this.querySelector('[data-main-buy]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"][data-available]')) this.updateVariant(event.target, true);
      }, options);
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choose]');
        if (!choice) return;
        const input = Array.from(this.querySelectorAll('input[type="radio"][data-available]')).find(input => input.value === choice.dataset.choose);
        if (!input || input.disabled) return;
        event.preventDefault();
        input.checked = true;
        this.updateVariant(input, true);
        this.form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      }, options);
      this.form.addEventListener('submit', event => {
        const selected = this.querySelector('input[type="radio"][data-available]:checked');
        if (!selected || selected.disabled || selected.dataset.available !== 'true') event.preventDefault();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.sticky.hidden = entry.isIntersecting;
      }, { threshold: 0 });
      this.observer.observe(this.buy);
      this.updateVariant(this.querySelector('input[type="radio"][data-available]:checked'), false);
    }
    updateVariant(input, updateUrl) {
      if (!input) return;
      const available = input.dataset.available === 'true';
      this.variantInput.value = input.value;
      this.variantInput.disabled = !available;
      this.querySelector('[data-express-checkout]').hidden = !available;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.querySelector('[data-current-price]').textContent = input.dataset.price;
      this.querySelector('[data-sticky-price]').textContent = input.dataset.price;
      const compare = this.querySelector('[data-current-compare]');
      compare.textContent = input.dataset.compare;
      compare.hidden = input.dataset.sale !== 'true';
      this.querySelector('[data-current-sale]').hidden = input.dataset.sale !== 'true';
      this.buy.disabled = !available;
      this.querySelector('[data-sticky-buy]').disabled = !available;
      this.querySelector('[data-button-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelector('[data-sticky-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelectorAll('[data-edition]').forEach(card => card.dataset.selected = String(card.dataset.edition === input.value));
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.ready = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maneo-tabi-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maneo-tabi')) {
  customElements.define('maneo-tabi', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('.tb-product-form');
      this.variantInput = this.form.querySelector('[data-canonical-variant]');
      if (!this.variantInput) {
        this.variantInput = document.createElement('input');
        this.variantInput.type = 'hidden';
        this.variantInput.name = 'id';
        this.variantInput.dataset.canonicalVariant = '';
        this.variantInput.value = this.form.querySelector('input[type="radio"]:checked')?.value || '';
        this.form.querySelectorAll('input[type="radio"][name="id"]').forEach(input => input.name = 'edition');
        this.form.prepend(this.variantInput);
      }
      this.sticky = this.querySelector('.tb-sticky');
      this.buy = this.querySelector('[data-main-buy]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"][data-available]')) this.updateVariant(event.target, true);
      }, options);
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choose]');
        if (!choice) return;
        const input = Array.from(this.querySelectorAll('input[type="radio"][data-available]')).find(input => input.value === choice.dataset.choose);
        if (!input || input.disabled) return;
        event.preventDefault();
        input.checked = true;
        this.updateVariant(input, true);
        this.form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      }, options);
      this.form.addEventListener('submit', event => {
        const selected = this.querySelector('input[type="radio"][data-available]:checked');
        if (!selected || selected.disabled || selected.dataset.available !== 'true') event.preventDefault();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.sticky.hidden = entry.isIntersecting;
      }, { threshold: 0 });
      this.observer.observe(this.buy);
      this.updateVariant(this.querySelector('input[type="radio"][data-available]:checked'), false);
    }
    updateVariant(input, updateUrl) {
      if (!input) return;
      const available = input.dataset.available === 'true';
      this.variantInput.value = input.value;
      this.variantInput.disabled = !available;
      this.querySelector('[data-express-checkout]').hidden = !available;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.querySelector('[data-current-price]').textContent = input.dataset.price;
      this.querySelector('[data-sticky-price]').textContent = input.dataset.price;
      const compare = this.querySelector('[data-current-compare]');
      compare.textContent = input.dataset.compare;
      compare.hidden = input.dataset.sale !== 'true';
      this.querySelector('[data-current-sale]').hidden = input.dataset.sale !== 'true';
      this.buy.disabled = !available;
      this.querySelector('[data-sticky-buy]').disabled = !available;
      this.querySelector('[data-button-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelector('[data-sticky-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelectorAll('[data-edition]').forEach(card => card.dataset.selected = String(card.dataset.edition === input.value));
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maneo-vestige-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maneo-vestige')) {
  customElements.define('maneo-vestige', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('.tb-product-form');
      this.variantInput = this.form.querySelector('[data-canonical-variant]');
      if (!this.variantInput) {
        this.variantInput = document.createElement('input');
        this.variantInput.type = 'hidden';
        this.variantInput.name = 'id';
        this.variantInput.dataset.canonicalVariant = '';
        this.variantInput.value = this.form.querySelector('input[type="radio"]:checked')?.value || '';
        this.form.querySelectorAll('input[type="radio"][name="id"]').forEach(input => input.name = 'edition');
        this.form.prepend(this.variantInput);
      }
      this.sticky = this.querySelector('.tb-sticky');
      this.buy = this.querySelector('[data-main-buy]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"][data-available]')) this.updateVariant(event.target, true);
      }, options);
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choose]');
        if (!choice) return;
        const input = Array.from(this.querySelectorAll('input[type="radio"][data-available]')).find(input => input.value === choice.dataset.choose);
        if (!input || input.disabled) return;
        event.preventDefault();
        input.checked = true;
        this.updateVariant(input, true);
        this.form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      }, options);
      this.form.addEventListener('submit', event => {
        const selected = this.querySelector('input[type="radio"][data-available]:checked');
        if (!selected || selected.disabled || selected.dataset.available !== 'true') event.preventDefault();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.sticky.hidden = entry.isIntersecting;
      }, { threshold: 0 });
      this.observer.observe(this.buy);
      this.updateVariant(this.querySelector('input[type="radio"][data-available]:checked'), false);
    }
    updateVariant(input, updateUrl) {
      if (!input) return;
      const available = input.dataset.available === 'true';
      this.variantInput.value = input.value;
      this.variantInput.disabled = !available;
      this.querySelector('[data-express-checkout]').hidden = !available;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.querySelector('[data-current-price]').textContent = input.dataset.price;
      this.querySelector('[data-sticky-price]').textContent = input.dataset.price;
      const compare = this.querySelector('[data-current-compare]');
      compare.textContent = input.dataset.compare;
      compare.hidden = input.dataset.sale !== 'true';
      this.querySelector('[data-current-sale]').hidden = input.dataset.sale !== 'true';
      this.buy.disabled = !available;
      this.querySelector('[data-sticky-buy]').disabled = !available;
      this.querySelector('[data-button-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelector('[data-sticky-text]').textContent = available ? this.dataset.add : this.dataset.sold;
      this.querySelectorAll('[data-edition]').forEach(card => card.dataset.selected = String(card.dataset.edition === input.value));
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
